import { catalogoService } from '@/services/catalogoService';

const getDefaultState = () => {
  return {
    catalogos: [],
    isModified: false
  }
}

const state = getDefaultState();

const getters = {
  catalogos: state => state.catalogos,
  isCatalogosModified: state => !!state.isModified
};

const actions = {
  async fetchCatalogos({ commit }) {
    commit('SET_LOADING', true);
    try {
      const response = await catalogoService.getCatalogos();
      commit('SET_CATALOGOS', response);
      commit('SET_LOADING', false);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
      commit('SET_LOADING', false);
    }
  },
  async fetchCatalogosAPI({ commit }) {
    commit('SET_LOADING', true);
    try {
      const response = await catalogoService.getCatalogosAPI();
      commit('SET_CATALOGOS', response);
      commit('SET_IS_CATALOGOS_MODIFIED', true);
      commit('SET_LOADING', false);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
      commit('SET_LOADING', false);
    }
  },
};

const mutations = {
  CLEAR_CATALOGOS_STATE: state => Object.assign(state, getDefaultState()),
  SET_CATALOGOS: (state, catalogos) => state.catalogos = catalogos,
  SET_IS_CATALOGOS_MODIFIED: (state, isModified) => state.isModified = isModified
};

export default {
  state,
  getters,
  actions,
  mutations
}